import { Component } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';

import { Subject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  IconComponent,
  InputComponent,
  FormFieldComponent,
  DropdownComponent,
  DropdownWidth,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-link-input',
  templateUrl: './link-input.component.html',
  styleUrls: ['./link-input.component.less'],
  imports: [
    FormFieldComponent,
    InputComponent,
    ReactiveFormsModule,
    IconComponent,
    TranslatePipe,
    DropdownComponent,
  ],
})
export class LinkInputComponent {
  protected readonly DropdownWidth = DropdownWidth;

  public save = new Subject<void>();
  public formControl = new UntypedFormControl();
}
